import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonButton,
    IonCheckbox,
    IonFab,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonAlert,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonSearchbar
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, arrowUp, closeOutline, add, person, barcode, business, locationOutline, trashOutline, createOutline, search } from 'ionicons/icons';
import ProductActions from '../../../actions/ProductActions';
import PosActions from '../../../actions/PosActions';

import { getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { DebounceInput } from 'react-debounce-input';

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;
}

interface IState {
    brands_array: any;
    ModalbrandShow: any;
    fieldsBrand: any;
    formErrors: any;
    datalogin: any;
    pages: any;
    total_rows: any;
    searchText: any;
    pageSize: any;
    current_count_data: any;
    brandsDB: any;
    data_pagin_brandsDB: any;
    alertDestroy: any;
}

class Brands extends React.Component<IProps, IState> {
    ModalBrand: React.RefObject<HTMLIonModalElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.ModalBrand = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            brands_array: [],
            ModalbrandShow: false,
            fieldsBrand: null,
            formErrors: {},
            datalogin: props.datalogin,

            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            pageSize: props.pageSize,
            current_count_data: props.current_count_data,

            brandsDB: [],
            data_pagin_brandsDB: [],
            alertDestroy: false
        }
    }

    componentDidMount() {

        this.setState({
            ModalbrandShow: false,
            fieldsBrand: {
                id: null,
                location_prices: []
            },
            datalogin: getLoginApp(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            console.log("getDataPaginInit");
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_brands',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_products/configuration'
        }, "api/get_list_brands");
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            brands_array: nextProps.data.data_default && nextProps.data.data_default.brands_array ? nextProps.data.data_default.brands_array : [],

            brandsDB: nextProps.data.brandsDB && nextProps.data.brandsDB ? nextProps.data.brandsDB : [],
            data_pagin_brandsDB: nextProps.data.data_pagin_brandsDB && nextProps.data.data_pagin_brandsDB ? nextProps.data.data_pagin_brandsDB : [],
            pages: nextProps.data.brandsDB && nextProps.data.brandsDB.pages ? nextProps.data.brandsDB.pages : 0,
            total_rows: nextProps.data.brandsDB && nextProps.data.brandsDB.total_rows ? nextProps.data.brandsDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_brandsDB ? nextProps.data.data_pagin_brandsDB.length : 0
        });

        if (nextProps.data.view_active == "dashboard_products/unidades") {
            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

    }

    openModalbrands(row: any) {
        let fieldsBrand = this.state.fieldsBrand;
        this.setState({
            ModalbrandShow: true,
            fieldsBrand: {
                id: null,
                name: '',
                description: '',
            }
        });
    }

    dismissModalbrands() {
        this.setState({
            ModalbrandShow: false,
            fieldsBrand: {
                id: null,
                name: '',
                description: '',
            }
        });
    }

    handleChangeBrand(event: any) {
        let fieldsBrand = this.state.fieldsBrand;
        fieldsBrand[event.target.name] = event.target.value;
        this.setState({
            fieldsBrand: fieldsBrand
        });
    }

    SaveDataPost() {
        let fieldsBrand = this.state.fieldsBrand;
        let error = false;
        let formErrors: any = {};
        if (this.state.fieldsBrand && this.state.fieldsBrand.name == "") { formErrors['name'] = "*Campo Requerido"; error = true };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fieldsBrand.id) {
                this.props.post_({
                    typeOption: 'updateDatabrand',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fieldsBrand: this.state.fieldsBrand,
                    view_active: 'dashboard_products/unidades'
                }, "api/updateDatabrand");
            } else {
                this.props.post_({
                    typeOption: 'saveDatabrand',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fieldsBrand: this.state.fieldsBrand,
                    view_active: 'dashboard_products/unidades'
                }, "api/saveDatabrand");
            }
            this.setState({
                ModalbrandShow: false,
            });
        }


    }

    edit_Brand(Brand: any) {

        let fieldsBrand = {
            id: Brand.id,
            name: Brand.name,
            description: Brand.description
        };

        if (Brand.location_prices) {
            this.setState({
                ModalbrandShow: true,
                fieldsBrand: fieldsBrand,
            });
        } else {
            this.setState({
                ModalbrandShow: true,
                fieldsBrand: fieldsBrand
            });
        }


    }

    render_brands(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><strong>Nombre:</strong> {row.name}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><strong>Descripción:</strong> {row.description}</label>
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small'
                            onClick={() => this.edit_Brand(row)}
                        >
                            <div>
                                <IonIcon
                                    color="#ffffff"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'}
                            onClick={
                                e => this.setState({ alertDestroy: true, fieldsBrand: row })
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDatabrand',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fieldsBrand: this.state.fieldsBrand,
            view_active: 'dashboard_products/unidades'
        }, "api/destroyDatabrand");
        this.setState({
            alertDestroy: false
        });
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    render() {
        const {
            fieldsBrand,
            ModalbrandShow,
            brands_array,
            formErrors,
            data_pagin_brandsDB,
            brandsDB,
            total_rows,
            current_count_data,
            pages,
            alertDestroy,
            searchText

        } = this.state;

        let data_render_brands = [];
        if (data_pagin_brandsDB && data_pagin_brandsDB.length > 0) {
            data_render_brands = [];
            data_render_brands = data_pagin_brandsDB.map((val: any, key: any) =>
                this.render_brands(val, key)
            );
        };
        return (
            <IonContent>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    //subHeader={'Verifique si conexión a internet.'}
                    message={'¿Desea eliminar la marca?'}
                    buttons={[
                        /*{
                          text: 'Conservar',
                          handler: e => {
                            this.SendCon(e);
                          }
                        },*/
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonRow>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>
                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>
                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar por nombre'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol col-12 size='12' >
                        {data_render_brands && data_render_brands.length > 0 ? data_render_brands : <IonCol col-12 size='12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                            <IonText color="medium" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: 'bold' }}>No hay valores disponibles</h5>
                            </IonText>
                        </IonCol>}
                    </IonCol>
                    <IonModal onDidDismiss={this.dismissModalbrands.bind(this)} isOpen={ModalbrandShow} ref={this.ModalBrand} trigger="open-modal">
                        <IonContent className="ion-padding">
                            <IonHeader >
                                <IonToolbar color="primary">
                                    <IonTitle>{fieldsBrand && fieldsBrand.id ? 'Editar Marca' : 'Nueva Marca'}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalbrands.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>

                            <IonRow>
                                <IonCol col-12 size='12'>
                                    <label>Nombre: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                        <input
                                            className='inputform'
                                            type="text"
                                            placeholder="Nombre de la Unidad"
                                            onChange={this.handleChangeBrand.bind(this)}
                                            value={(fieldsBrand && fieldsBrand.name) ?? ""}
                                            name="name" />
                                    </div>
                                    {formErrors && formErrors.name && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.name}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Descripción: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                        <input
                                            className='inputform'
                                            type="text"
                                            placeholder="Descripción"
                                            onChange={this.handleChangeBrand.bind(this)}
                                            value={(fieldsBrand && fieldsBrand.description) ?? ""}
                                            name="description" />
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={() => this.dismissModalbrands()}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',

                        }}
                    >
                        <IonFabButton onClick={(e) => this.openModalbrands(e)} color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonRow>
                <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                    onIonInfinite={(event) => {
                        this.getDataPaginInit();
                    }}
                >
                    <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>

                </IonInfiniteScroll>
            </IonContent>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        post_: PropTypes.func.isRequired,

    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ProductActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ProductActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ProductActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Brands);
